export default __webpack_public_path__ + "static/media/stella.a1dba179.png";